import { useEffect } from "react";
import { useApiResource } from "../../../hooks/useApiResource";
import { AIRPORT_CODE_PARAMETER } from "../../../utils/common/Constants";
import { MapErrorId } from "../../../utils/maps/MapConstants";
import GateMarkers from "../map-markers/gate-stand-markers/GateMarkers";
import RunwayMarkers from "../map-markers/runway-markers/RunwayMarkers";

const resourcesEndpoint = process.env.REACT_APP_API_RESOURCEAVAILABILITY;
const payload = {
  ResourcesAvailabilityFilters: [
    {
      type: "STANDS",
      includeGeographicData: true,
      includeFlightData: true,
      excludeClassifications: ["REMOTE"],
      excludeOccupancies: ["UNKNOWN"],
      excludeStatuses: null,
    },
    {
      type: "RUNWAY",
      includeGeographicData: true,
      includeFlightData: false,
    },
  ],
};

export interface IMapResourceMarkersProps {
  airportId: string;
  showGates: boolean;
  showRSC: boolean;
  setMapApiFailures: (errorID: MapErrorId, isReset?: boolean) => void;
}

const MapResources: React.FC<IMapResourceMarkersProps> = ({
  airportId,
  showGates,
  showRSC,
  setMapApiFailures,
}) => {
  const resourceUrl =
    resourcesEndpoint?.replace(AIRPORT_CODE_PARAMETER, airportId) || "";

  const { data: resourceData, isError } = useApiResource({
    queryKey: ["map-resource-markers", airportId],
    url: resourceUrl,
    fetchOnPost: true,
    fetchPayload: payload,
    refetchInterval: 60000,
    enabled: showGates || showRSC,
  });

  useEffect(() => {
    if (isError) {
      setMapApiFailures("RESOURCES");
    } else {
      setMapApiFailures("RESOURCES", true);
    }
  }, [isError, setMapApiFailures]);

  const runways = resourceData?.data?.RUNWAY ?? [];
  const stands = resourceData?.data?.STANDS ?? [];

  if (!showGates && !showRSC) {
    return null;
  }

  return (
    <>
      {showRSC && (
        <RunwayMarkers airportCode={airportId} runwayData={runways} />
      )}
      {showGates && <GateMarkers airportCode={airportId} gatesData={stands} />}
    </>
  );
};

export default MapResources;
